module.exports = __webpack_public_path__ + "img/tu_schedule_dayoff.75a38d38.svg";